import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Style/typo.css";
import "./assets/css/style-chatbot.css";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import Chat1 from "./assets/image/chat1.png";
import ChatBlock1 from "./assets/image/chat-block1.png";
import ChatBlock2 from "./assets/image/chat-block2.png";
import ChatBlock3 from "./assets/image/chat-block3.png";
import ChatVector from "./assets/image/chat-vector.png";
import ChatGift from "./assets/image/Chatbot.gif";
import ChatIntroduce1 from "./assets/image/chat-intro1.png";
import ChatIntroduce2 from "./assets/image/chat-intro2.png";
import ChatIntroduce3 from "./assets/image/chat-intro3.png";
import ChatIntroduce4 from "./assets/image/chat-intro4.png";
import ChatHelp1 from "./assets/image/chat-help1.png";
import ChatHelp2 from "./assets/image/chat-help2.png";
import Chatbotimg from "./assets/image/chatbot1.png";
import ChatContact from "./assets/image/chat-contact.png";
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";

function Chatbot() {
    const [isGiftVisible, setIsGiftVisible] = useState(false);
    const giftRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsGiftVisible(true);
                } else {
                    setIsGiftVisible(false);
                }
            },
            {
                threshold: 0.1,
            }
        );

        if (giftRef.current) {
            observer.observe(giftRef.current);
        }

        return () => {
            if (giftRef.current) {
                observer.unobserve(giftRef.current);
            }
        };
    }, []);

    return (
        <div>
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />

            <div className="chatbot">
                <div className="chat-banner">
                    <div className="fit-chat-box">
                        <FadeInSection>
                            <div className="chat-wrap">
                                <div className="chat-box chat-box-left">
                                    <div className="chat-banner-left">
                                        <div>
                                            <p className="typo-32-mb wh-color">Help 챗봇</p>
                                            <p className="typo-16 wh-color">
                                                회사 제품/서비스 매뉴얼, 이용 가이드, FAQ, 공지 등 고객지원 자료를 업로드하면<br />AI가 내용을 분석해 외부 고객의 질문에 실시간으로 정확한 답변을 제공합니다.<br />회사 상품에 대한 자료를 지식창고에 등록해두기만 하면,<br />AI가 필요한 정보를 찾아 언제든 일관된 안내를 제공하는 고객 문의 대응 창구가 됩니다.
                                            </p>
                                        </div>

                                        <div class="feature-btn-gr theme-purple">
                                            <a class="url-btn typo-14" href="https://hanbiro.com/#/groupware-free-trial">
                                                <button class="btn--default btn--primary">데모 신청</button>
                                            </a>
                                            {/* <a class="url-btn typo-14" href="https://hanbiro.com/#/pricing">
                                                <button class="btn--default btn--secondary">요금안내</button>
                                            </a> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="chat-box chat-box-right">
                                    <div className="chat-box-img">
                                        <img src="https://hanbiro.com/assets/images/cloud/chatbot-banner-1.png" alt="chat1" />
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                        
                    </div>
                    
                </div>

                <div className="chat-block">
                    <div className="fit-chat-box">
                        <FadeInSection>
                            <div className="chat-title">
                                <p className="typo-32-mb t-pl">Help 챗봇 응답 구조</p>
                                <p className="typo-16">제품·서비스 자료를 기반으로 외부 고객 문의에 응답하는 AI Help ChatBot</p>
                            </div>

                            <div className="chat-block-structure">
                                <div className="chat-structure-img">
                                    <img src="https://hanbiro.com/assets/images/cloud/chatbot-architect-1.png" alt="chat-block1" />
                                </div>
                                <div className="chat-structure-img chatbot-vector">
                                    <img src={ChatVector} alt="chat-vector" />
                                </div>
                                <div className="chat-structure-img">
                                    <img src="https://hanbiro.com/assets/images/cloud/chatbot-architect-2.png" alt="chat-block2" />
                                </div>
                                <div className="chat-structure-img chatbot-vector">
                                    <img src={ChatVector} alt="chat-vector" />
                                </div>
                                <div className="chat-structure-img">
                                    <img src="https://hanbiro.com/assets/images/cloud/chatbot-architect-3.png" alt="chat-block3" />
                                </div>
                            </div>
                        </FadeInSection>
                    </div>
                </div>

                <div ref={giftRef} className={`chat-block chat-gift ${isGiftVisible ? 'chat-gift-visible' : ''}`}>
                    <div className="fit-chat-box">
                        <div className="chat-title">
                            <p className="typo-32 purple-color">궁금한 건, 바로 물어보세요 !</p>
                            <p className="typo-32 purple-color">챗봇이 즉시 답변합니다.</p>
                        </div>

                        <div className="chat-gift-img">
                            <div className="chat-gift-box">
                                <img src={ChatGift} alt="chat-gift" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="chat-block">
                    <div className="fit-chat-box">
                        <div className="chat-title">
                            <p className="typo-32 t-pl">Hanbiro ChatBot 도입 효과</p>
                        </div>

                        <div className="chat-introduce">
                            <div className="chat-introduce-wrap">
                                <div className="chat-introduce-box bg-purple">
                                    <div className="introduce-box-title" data-aos="flip-up" data-aos-duration="500" data-aos-offset="20">
                                       <img src={ChatIntroduce1} alt="chat-introduce1" />
                                       <p className="typo-21-nm typo-medium">고객 문의 응답 속도 향상 & 상담 효율 개선</p>
                                    </div>

                                    <div className="introduce-box-content">
                                        <p className="typo-16">상품 매뉴얼, 이용 가이드, 요금 정책, FAQ 등 고객이 자주 문의하는 내용을 
                                            AI가 즉시 안내하여 대기 시간 없이 빠른 답변을 제공합니다.<br/>
                                            그 결과 고객은 필요한 정보를 바로 확인할 수 있고, 상담 인력은 반복 문의 대응 
                                            부담에서 벗어나 보다 중요한 이슈에 집중합니다.
                                        </p>
                                    </div>
                                </div>
                                <div className="chat-introduce-box bg-yellow">
                                    <div className="introduce-box-title" data-aos="flip-up" data-aos-duration="500" data-aos-offset="20">
                                       <img src={ChatIntroduce2} alt="chat-introduce2" />
                                       <p className="typo-21-nm typo-medium">정확하고 일관된 고객 안내 제공</p>
                                    </div>

                                    <div className="introduce-box-content">
                                        <p className="typo-16">안내 주체에 따라 달라질 수 있던 설명 방식이나 해석 차이를 줄이고
                                            공식 상품 매뉴얼과 정책을 기반으로 AI가 동일한 기준의 답변을 제공합니다.<br/>
                                            이를 통해 오안내로 인한 클레임을 예방하고, 고객에게 신뢰할 수 있는 답변을 합니다.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="chat-introduce-wrap chat-introduce-wrap-2">
                                <div className="chat-introduce-box bg-yellow">
                                    <div className="introduce-box-title" data-aos="flip-up" data-aos-duration="500" data-aos-offset="20">
                                       <img src={ChatIntroduce3} alt="chat-introduce3" />
                                       <p className="typo-21-nm typo-medium">상담 채널 확장으로 고객 만족도 향상</p>
                                    </div>

                                    <div className="introduce-box-content">
                                        <p className="typo-16">운영 시간이나 인력에 상관없이 고객이 궁금할 때 바로 기본적인 문의를 해결하여
                                        전체적인 고객 만족도가 높아집니다.<br/>
                                        특히 근무 시간 외 문의나 해외 고객 응대에 효과적입니다.
                                        </p>
                                    </div>
                                </div>
                                <div className="chat-introduce-box bg-purple">
                                    <div className="introduce-box-title" data-aos="flip-up" data-aos-duration="500" data-aos-offset="20">
                                       <img src={ChatIntroduce4} alt="chat-introduce4" />
                                       <p className="typo-21-nm typo-medium">고객 문의 데이터를 활용한 서비스 개선</p>
                                    </div>

                                    <div className="introduce-box-content">
                                        <p className="typo-16">AI 챗봇에 축적되는 고객 질문과 응답 이력은 고객이 실제로 궁금해하는 포인트와
                                        상품·서비스의 개선 필요 영역을 파악할 수 있는 중요한 데이터가 됩니다.<br/>
                                        이를 바탕으로 FAQ 보완, 매뉴얼 개정, 상품 개선 등  고객 중심의 서비스 고도화를
                                        지속적으로 추진합니다. 
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="chat-block chatbot-block-padding-top-30">
                    <div className="fit-chat-box">
                        <div className="chat-title">
                            <p className="typo-32 t-pl">Help 챗봇 사용 방법</p>
                        </div>

                        <div className="chat-help">
                            <div className="help-chatbot">
                                <p className="typo-32-mb">회사 상품·서비스 지식베이스 등록하기</p>
                            </div>

                            <div className="help-box-content">
                                <FadeInSection>
                                    <div className="chat-help-wrap">
                                        <div className="chat-help-box chat-help-border">
                                            <div className="chat-help-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/view-knowledge-article-1.png" alt="chat-help1" />
                                            </div>
                                        </div>
                                        <div className="chat-help-box">
                                            <ul>
                                                <li>회사 상품 및 서비스 안내에 활용할 자료를 등록합니다.</li>
                                                <li>상품 매뉴얼, 이용 가이드, FAQ 등 고객 응대에 필요한 문서를 카테고리별로 관리하고, 검색을 위해 태그를 설정합니다.</li>
                                                <li>원하는 형식으로 내용을 구성하여 고객에게 전달될 안내 기준을 정의합니다.</li>
                                            </ul>
                                        </div>                                    
                                    </div>
                                </FadeInSection>
                            </div>

                            <div className="help-box-content">
                                <FadeInSection>
                                    <div className="chat-help-wrap">
                                        <div className="chat-help-box chat-help-border">
                                            <div className="chat-help-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/create-knowledge-article-1.png" alt="chat-help2" />
                                            </div>
                                        </div>
                                        <div className="chat-help-box">
                                            <ul>
                                                <li>다양한 표현과 상황을 학습시키기 위해, 유사한 내용도 유사청크로 등록합니다.</li>
                                                <li>유사청크는 AI에 기반하여 자동으로 3개까지 생성됩니다.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </FadeInSection>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="chat-block chatbot-block-padding-top-30">
                    <div className="fit-chat-box">
                        <FadeInSection>
                            <div className="help-chatbot">
                                <p className="typo-32-mb">Help ChatBot 질의응답 확인</p>
                                <p className="typo-16">지식창고 데이터를 기반으로 실시간 질의 응답 화면 예시 </p>
                            </div>

                            <div className="help-chatbot-img bg-purple">
                                <img src="https://hanbiro.com/assets/images/cloud/chatbot-ui-2.png" alt="chatbot" />
                            </div>
                        </FadeInSection>
                    </div>
                </div>
                
                <div className="chat-block chatbot-block-padding-top-30">
                    <div className="fit-chat-box">
                        <div className="question-chat-title">
                            <p className="typo-32">자주하는 질문</p>
                        </div>

                        <div className="chatbot-questions">
                            <div class="accordion " id="accordionChatbot">
                                <div class="accordion-item chatbot-questions-items">
                                    <h2 class="accordion-header chatbot-accordion-header">
                                        <button
                                            class="accordion-button chatbot-accordion-button gw-accordion-btn"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseChatOne"
                                            aria-expanded="true"
                                            aria-controls="collapseChatOne"
                                        >
                                            <span className="typo-21-nm typo-medium">1. 챗봇은 어떤 문서를 기반으로 답변하나요?</span>
                                        </button>
                                    </h2>
                                    <div className="chatbot-questions-divider"></div>
                                    <div id="collapseChatOne" class="accordion-collapse collapse show chatbot-collapse" data-bs-parent="#accordionChatbot">
                                        <div class="accordion-body">
                                            <div className="chatbot-questions-bd">
                                                <span className="chatbot-description-item typo-16">
                                                    헬프 챗봇은 직원들이 등록한 지식창고 데이터를 기반으로 답변합니다.<br/>
                                                    회사 내부에서 직접 입력·관리한 지식 콘텐츠를 학습하여,
                                                    해당 데이터 범위 내에서만 답변을 제공합니다.<br/>
                                                    이를 통해 직원 문의뿐만 아니라 외부 고객이 문의하는 내용에도
                                                    일관되고 정확한 답변을 제공할 수 있습니다.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item chatbot-questions-items">
                                    <h2 class="accordion-header chatbot-accordion-header">
                                        <button
                                            class="accordion-button  collapsed chatbot-accordion-button "
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseChatTwo"
                                            aria-expanded="false"
                                            aria-controls="collapseChatTwo"
                                        >
                                            <span className="typo-21-nm typo-medium">2. 챗봇이 잘못된 답변을 제공하면 어떻게 해야하나요 ?</span>
                                        </button>
                                    </h2>
                                    <div className="chatbot-questions-divider"></div>
                                    <div id="collapseChatTwo" class="accordion-collapse collapse chatbot-collapse" data-bs-parent="#accordionChatbot">
                                        <div class="accordion-body">
                                            <div className="chatbot-questions-bd">
                                                <span className="chatbot-description-item typo-16">
                                                    챗봇 답변이 부정확할 경우, 관리자는 기존 문서를 수정하거나 새로운 문서를 추가 등록하여 답변 내용을 보완할 수 있습니다.<br/>
                                                    문서가 최신 상태로 유지될수록, 챗봇의 답변 정확도 또한 함께 개선됩니다.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item chatbot-questions-items">
                                    <h2 class="accordion-header chatbot-accordion-header">
                                        <button
                                            class="accordion-button collapsed chatbot-accordion-button "
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseChatThree"
                                            aria-expanded="false"
                                            aria-controls="collapseChatThree"
                                        >
                                            <span className="typo-21-nm typo-medium">3. 챗봇 답변은 실시간으로 업데이트되나요?</span>
                                        </button>
                                    </h2>
                                    <div className="chatbot-questions-divider"></div>
                                    <div id="collapseChatThree" class="accordion-collapse collapse chatbot-collapse" data-bs-parent="#accordionChatbot">
                                        <div class="accordion-body">
                                            <div className="chatbot-questions-bd">
                                                <span className="chatbot-description-item typo-16">
                                                    네. 관리자가 데이터를 수정하거나 새 데이터를 등록하면
                                                    해당 내용은 챗봇 답변에 즉시 반영됩니다.<br/>
                                                    별도의 학습 작업 없이도 최신 정보가 적용됩니다.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item chatbot-questions-items">
                                    <h2 class="accordion-header chatbot-accordion-header">
                                        <button
                                            class="accordion-button collapsed chatbot-accordion-button "
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseChatFour"
                                            aria-expanded="false"
                                            aria-controls="collapseChatFour"
                                        >
                                            <span className="typo-21-nm typo-medium">4. 지원되는 언어는 어떤 것이 있나요?</span>
                                        </button>
                                    </h2>
                                    <div className="chatbot-questions-divider"></div>
                                    <div id="collapseChatFour" class="accordion-collapse collapse chatbot-collapse" data-bs-parent="#accordionChatbot">
                                        <div class="accordion-body">
                                            <div className="chatbot-questions-bd">
                                                <span className="chatbot-description-item typo-16">
                                                    헬프챗봇은 저장된 지식 데이터를 기반으로 답변을 생성한 후,
                                                    해당 내용을 사용자가 원하는 언어로 변환하여 제공하는 방식으로 동작합니다.<br/>
                                                    이로 인해 언어별로 별도의 문서를 준비하지 않아도 되며,
                                                    동일한 데이터로도 다국어 응답이 가능합니다.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item chatbot-questions-items chatbot-questions-after">
                                    <h2 class="accordion-header chatbot-accordion-header">
                                        <button
                                            class="accordion-button collapsed chatbot-accordion-button "
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseChatFive"
                                            aria-expanded="false"
                                            aria-controls="collapseChatFive"
                                        >
                                            <span className="typo-21-nm typo-medium">5. 챗봇 사용 권한이 따로 있나요?</span>
                                        </button>
                                    </h2>
                                    <div className="chatbot-questions-divider"></div>
                                    <div id="collapseChatFive" class="accordion-collapse collapse chatbot-collapse" data-bs-parent="#accordionChatbot">
                                        <div class="accordion-body">
                                            <div className="chatbot-questions-bd">
                                                <span className="chatbot-description-item typo-16">
                                                    챗봇은 그룹웨어에 로그인한 사용자라면 별도의 설정 없이 누구나 사용할 수 있습니다.<br/>
                                                    (단, 메뉴에 대한 접근 권한은 관리자설정에 따라 달라질 수 있습니다.)
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="chat-block chat-contact">
                    <div className="fit-chat-box">
                        <div className="chat-contact-wrap">
                            <div className="chat-contact-left">
                                    <div className="chat-contact-left-content">
                                        <p className="typo-21-nm wh-color">Contact</p>
                                        <p className="typo-32 wh-color">Let's Connect!</p>
                                        <p className="typo-16 wh-color">Unleash your potential with our innovative solutions. Let's build the future together!</p>
                                    </div>
                                    <div class="feature-btn-gr theme-purple">
                                        <a class="url-btn typo-14" href="#">
                                            <button class="btn--default btn--primary">Button</button>
                                        </a>
                                        
                                    </div>
                            </div>
                            <div className="chat-contact-right">
                                    <img src="https://hanbiro.com/assets/images/cloud/chatbot-cta.png" alt="ChatContact" />
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>

            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default Chatbot;
